var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrangeVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 47.613 6.011 l 8.531 -4.732 c 2.864 -1.588 6.47 -0.276 7.643 2.782 l 3.494 9.108 c 0.666 1.735 2.179 3.005 4.003 3.359 l 9.577 1.859 c 3.215 0.624 5.134 3.948 4.067 7.044 l -3.178 9.223 c -0.606 1.757 -0.263 3.702 0.907 5.147 l 6.141 7.58 c 2.061 2.544 1.395 6.324 -1.412 8.01 l -8.363 5.022 c -1.593 0.957 -2.581 2.667 -2.613 4.526 l -0.168 9.754 c -0.056 3.274 -2.996 5.741 -6.231 5.228 l -9.635 -1.528 c -1.836 -0.291 -3.692 0.384 -4.911 1.787 l -6.398 7.364 c -2.148 2.472 -5.986 2.472 -8.133 0 l -6.398 -7.364 c -1.219 -1.403 -3.075 -2.079 -4.911 -1.787 l -9.635 1.528 c -3.234 0.513 -6.174 -1.954 -6.231 -5.228 l -0.168 -9.754 c -0.032 -1.858 -1.02 -3.569 -2.613 -4.526 l -8.363 -5.022 c -2.807 -1.686 -3.474 -5.466 -1.412 -8.01 l 6.141 -7.58 c 1.17 -1.444 1.513 -3.389 0.907 -5.147 l -3.178 -9.223 c -1.067 -3.096 0.852 -6.42 4.067 -7.044 l 9.577 -1.859 c 1.825 -0.354 3.338 -1.624 4.003 -3.359 l 3.494 -9.108 c 1.173 -3.057 4.779 -4.37 7.643 -2.782 l 8.531 4.732 C 44.012 6.913 45.988 6.913 47.613 6.011 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,113,51)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 41.325 61.54 c -1.134 0 -2.215 -0.481 -2.974 -1.325 l -12.35 -13.73 c -1.477 -1.642 -1.343 -4.171 0.299 -5.649 s 4.171 -1.343 5.649 0.299 l 9.318 10.359 l 18.732 -21.652 c 1.444 -1.67 3.97 -1.854 5.643 -0.408 c 1.671 1.445 1.854 3.971 0.408 5.642 l -21.7 25.081 c -0.751 0.868 -1.838 1.371 -2.986 1.383 C 41.351 61.54 41.338 61.54 41.325 61.54 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeVerified);
export default __webpack_public_path__ + "static/media/orangeVerified.9ae44129dc243656536528334db843b5.svg";
export { ForwardRef as ReactComponent };